/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Referrals_Page_Meta_DescriptionInputs */

const en_referrals_page_meta_description = /** @type {(inputs: Referrals_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share your Glider referral link, invite new users, and track referral earnings.`)
};

const de_referrals_page_meta_description = /** @type {(inputs: Referrals_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilen Sie Ihren Glider-Empfehlungslink, laden Sie neue Benutzer ein und verfolgen Sie Ihre Empfehlungsprämien.`)
};

const pt_br2_referrals_page_meta_description = /** @type {(inputs: Referrals_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartilhe seu link de indicação da Glider, convide novos usuários e acompanhe seus ganhos por indicação.`)
};

const tr_referrals_page_meta_description = /** @type {(inputs: Referrals_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glider davet bağlantınızı paylaşın, yeni kullanıcılar davet edin ve davet kazançlarınızı takip edin.`)
};

const zh_cn2_referrals_page_meta_description = /** @type {(inputs: Referrals_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分享你的 Glider 推荐链接，邀请新用户，并追踪推荐收益。`)
};

const zh_hk2_referrals_page_meta_description = /** @type {(inputs: Referrals_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分享你的 Glider 推薦連結，邀請新用戶，並追蹤推薦收益。`)
};

const ko_kr2_referrals_page_meta_description = /** @type {(inputs: Referrals_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glider 추천 링크를 공유하고 신규 사용자를 초대해 추천 수익을 확인하세요.`)
};

const ru_ru2_referrals_page_meta_description = /** @type {(inputs: Referrals_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Делитесь реферальной ссылкой Glider, приглашайте новых пользователей и отслеживайте реферальный доход.`)
};

const es_419_referrals_page_meta_description = /** @type {(inputs: Referrals_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparte tu enlace de referido de Glider, invita a nuevos usuarios y sigue tus ganancias por referidos.`)
};

/**
* | output |
* | --- |
* | "Share your Glider referral link, invite new users, and track referral earnings." |
*
* @param {Referrals_Page_Meta_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const referrals_page_meta_description = /** @type {((inputs?: Referrals_Page_Meta_DescriptionInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Referrals_Page_Meta_DescriptionInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_referrals_page_meta_description(inputs)
	if (locale === "de") return de_referrals_page_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_referrals_page_meta_description(inputs)
	if (locale === "tr") return tr_referrals_page_meta_description(inputs)
	if (locale === "zh-CN") return zh_cn2_referrals_page_meta_description(inputs)
	if (locale === "zh-HK") return zh_hk2_referrals_page_meta_description(inputs)
	if (locale === "ko-KR") return ko_kr2_referrals_page_meta_description(inputs)
	if (locale === "ru-RU") return ru_ru2_referrals_page_meta_description(inputs)
	return es_419_referrals_page_meta_description(inputs)
});